
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  --tag-icon-size:0.75rem;

  font-family:var(--ff-bold);
  color:var(--brand-dark-blue-900);
  border-radius:4px;
  background-color:var(--brand-green-900);
  display:inline-block;
  font-size:var(--fs-lg);
  line-height:var(--lh-xs);
  padding:0.375rem 0.5rem 0.3125rem;
  text-transform:uppercase;
}
  :host a{
    text-decoration:none;
  }

:host([is-facet]),
:host([is-facet='true']){
  transition:transform 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

:host([is-facet]) a, :host([is-facet='true']) a{
    display:flex;
    gap:var(--spacing-2);
    align-items:center;
  }

:host([is-facet]):focus,
  :host([is-facet]):hover,
  :host([is-facet='true']):focus,
  :host([is-facet='true']):hover{
    transform:scale(1.05);
  }

:host([is-facet]) .facet-item__status.js-facet-deactivate, :host([is-facet='true']) .facet-item__status.js-facet-deactivate{
    display:none;
  }
`;